import { twMerge } from "tailwind-merge";

interface NotificationContentProps {
  title?: string;
  description?: string;
  containerClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  children?: React.ReactNode;
}

const NotificationContent = ({
  title = "",
  description = "",
  containerClassName,
  titleClassName,
  descriptionClassName,
  children
}: NotificationContentProps) => {
  const hasContent = title && description;

  return (
    <div
      className={twMerge(
        `flex flex-col items-start`,
        hasContent ? "gap-2" : "",
        containerClassName
      )}
    >
      {title && (
        <p
          className={twMerge(
            "text-base font-bold text-txtHeading",
            titleClassName
          )}
        >
          {title}
        </p>
      )}
      {description && (
        <p className={twMerge("text-sm text-txtHeading", descriptionClassName)}>
          {description}
        </p>
      )}
      {children}
    </div>
  );
};

export default NotificationContent;
